module.exports = __webpack_public_path__ + "static/img/013酒庄官网4.fc736a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/013酒庄官网4.jpg
// module id = Sc2C
// module chunks = 0